import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    GetMaxContractEndStatus: 'idle',
    GetMaxContractEndError: undefined as any,
    ResetContractEndStatus: 'idle',
    ResetContractEndError: undefined as any,

    flbelResetEndList: [] as any[],
    contractMaxEndDate: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const GetMaxContractEnd = createAsyncThunk('flbelResetEndSlice/GetMaxContractEnd', async ({ parentModel }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ContractMenu_GetMaxContractEnd/?lflbelid=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { GetMaxContractEndStatus } = getState().flbelResetEndSlice
        return GetMaxContractEndStatus !== 'pending'
    }
})

export const ResetContractEnd = createAsyncThunk('flbelResetEndSlice/ResetContractEnd', async ({ parentModel, flbelResetEnd }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/ContractMenu_ResetContractEnd/`,
        prepareData({ FlbelId: parentModel.HDR_ID, ContractEnd: flbelResetEnd.ContractEnd, AnteilSollbetrag: flbelResetEnd.AnteilSollVariante }),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { ResetContractEndStatus } = getState().flbelResetEndSlice
        return ResetContractEndStatus !== 'pending'
    }
})

const FlbelResetEndSlice = createSlice({
    name: 'flbelResetEndSlice',
    initialState,
    reducers: {
        resetGetMaxContractEnd: (state) => {
            state.contractMaxEndDate = undefined
            state.GetMaxContractEndError = undefined
        },
        resetGetMaxContractEndError: (state) => {
            state.GetMaxContractEndError = undefined
        },
        resetResetContractEndError: (state) => {
            state.ResetContractEndError = undefined
        },
        removeFromFlbelResetEndListById: (state, action) => {
            state.flbelResetEndList = state.flbelResetEndList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromFlbelResetEndListByIds: (state, action) => {
            state.flbelResetEndList = state.flbelResetEndList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flbelResetEndList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.GetMaxContractEndStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.flbelResetEndList = []
            state.GetMaxContractEndStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(GetMaxContractEnd.pending, (state) => {
            state.GetMaxContractEndStatus = 'pending'
            state.GetMaxContractEndError = undefined
        })
        builder.addCase(GetMaxContractEnd.fulfilled, (state, action) => {
            state.GetMaxContractEndStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.contractMaxEndDate = newItem
            }
        })
        builder.addCase(GetMaxContractEnd.rejected, (state, action) => {
            state.GetMaxContractEndStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.GetMaxContractEndError = action.error.message
            } else {
                state.GetMaxContractEndError = action.payload
            }
        })

        builder.addCase(ResetContractEnd.pending, (state) => {
            state.ResetContractEndStatus = 'pending'
            state.ResetContractEndError = undefined
        })
        builder.addCase(ResetContractEnd.fulfilled, (state, action) => {
            state.ResetContractEndStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flbelResetEndList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flbelResetEndList.push(newItem) }
                else { state.flbelResetEndList[i] = { ...state.flbelResetEndList[i], ...newItem } }
            }
        })
        builder.addCase(ResetContractEnd.rejected, (state, action) => {
            state.ResetContractEndStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.ResetContractEndError = action.error.message
            } else {
                state.ResetContractEndError = action.payload
            }
        })

    }
})

export const {
    resetGetMaxContractEnd,
    resetGetMaxContractEndError,
    resetResetContractEndError,
    removeFromFlbelResetEndListById,
    removeFromFlbelResetEndListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FlbelResetEndSlice.actions
export default FlbelResetEndSlice.reducer
